import { useQuery } from '@tanstack/react-query';

import type { FileAttachmentTypeT } from '@lotushealth/lotushealth_js_sdk/schemas';

import { fetchAttachmentViewUrl } from '../api/fetchAttachmentViewUrl.js';
import { fileAttachmentKeys } from './keys.js';

export interface UseAttachmentViewUrlQueryOptions {
  userId: string;
  attachmentId: string;
  fileType: FileAttachmentTypeT;
  enabled?: boolean;
}

export function attachmentViewUrlQueryDefinition(
  userId: string,
  attachmentId: string,
  fileType: FileAttachmentTypeT
) {
  return {
    queryKey: fileAttachmentKeys.viewUrl(userId, attachmentId, fileType),
    queryFn: ({ signal }: { signal?: AbortSignal }) =>
      fetchAttachmentViewUrl({ userId, attachmentId, fileType }, signal),
    staleTime: 2 * 60 * 1000,
  } as const;
}

export function useAttachmentViewUrlQuery({
  userId,
  attachmentId,
  fileType,
  enabled = true,
}: UseAttachmentViewUrlQueryOptions) {
  return useQuery({
    ...attachmentViewUrlQueryDefinition(userId, attachmentId, fileType),
    enabled,
  });
}
